import React from "react";
import { Button, Card, Container } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import NavbarMenu from "../components/heroSection/NavbarMenu";
import Footer from "../components/footer/Footer";
import SEO from "../components/SEO";

export default function ThankYou() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title={t("thankYou.seoTitle")}
        description={t("thankYou.seoDescription")}
        keywords={t("thankYou.seoKeywords")}
      />
      <NavbarMenu />
      <section className="py-5 dark-bg-primary">
        <Container className="py-5">
          <Card
            className="mx-auto text-center border-0 shadow dark-bg-card"
            style={{ maxWidth: "680px" }}
          >
            <Card.Body className="p-4 p-md-5">
              <FaCheckCircle size={56} className="text-orange mb-4" />
              <h1 className="h3 fw-bold mb-3">
                {t("thankYou.heading")}
              </h1>
              <p className="text-grey-light mb-4">
                {t("thankYou.subtext")}
              </p>
              <Button
                type="button"
                className="bg-orange border-0 px-4"
                onClick={() => navigate("/")}
              >
                {t("thankYou.backHome")}
              </Button>
            </Card.Body>
          </Card>
        </Container>
      </section>
      <Footer />
    </>
  );
}
